<mat-card>
  <div class="user-details-wrapper">
    <div class="avatar-container">
      <img src="{{user_detail.imageURL}}" alt="User Detail">
    </div>
    <div class="user-detail">
      <h3>{{user_detail.fname}} {{user_detail.lname}}</h3>
       <p>{{user_detail.contact}}</p>
       <p><span>{{user_detail.language}}</span> <span *ngIf="user_detail.country != null">/{{user_detail.country}}</span></p>
    </div>
    <button class="edit-btn" (click)="openProfile()">
      <img src="../../../assets/icon/edit-org.svg" alt=""> Edit
    </button>
  </div>
</mat-card>
